// Angular
import { Inject, Injectable, NgModule } from '@angular/core';
// Type
import { APP_CONTEXT, SacAIPData } from './shared/types/sac-aip.intent.type';
// Service
import { IntegrationService } from './shared/services/integration.service';

@Injectable()
@NgModule()
export class SacAipIntent {
  applicationPath: string;
  firmId: string;
  firmName: string;
  firmType: string;
  contextId: string;
  contextType: string;
  userName: string;
  sessionId: string;
  context: string;
  isEmployee: boolean;

  constructor(
    @Inject(APP_CONTEXT) private aipContext: SacAIPData,
    private integrationService: IntegrationService
  ) {
    // let userContext = {
    //   ApplicationPath: '',
    //   FirmID: '',
    //   FirmName: '',
    //   FirmType: '',
    //   ContextID: '',
    //   ContextType: '',
    //   UserName: '',
    //   SessionId: '',
    //   Context: ''
    // };
    // if (window['userContext']) {
    //   userContext = <SacAIPData>JSON.parse(window['userContext']);
    // }
    if (aipContext) {
      this.applicationPath = aipContext.applicationPath;
      this.firmId = aipContext.firmID;
      this.firmName = aipContext.firmName;
      this.firmType = aipContext.firmType;
      this.contextId = aipContext.contextID;
      this.contextType = aipContext.contextType;
      this.userName = aipContext.userName;
      this.sessionId = aipContext.sessionId;
      this.context = aipContext.context;
      this.isEmployee = aipContext.isEmployee;
    }
  }

  getFreshToken = function (objCallBack?: any) {
    let response = '';
    const referrer = !window.location.href.includes('?') ? window.location.href + '?' + this.context : window.location.href;
    fetch('/SI2/home/utilities/SsoInitiatorOAuth.ashx/?referrer=' + referrer + '&contextId=' + this.contextId)
      .then((response) => response.json())
      .then((resp) => {
        if (resp && resp.Message) {
          if (resp.Message === 'SessionInvalidOrExpired') {
            location.href = '/SI2/SecAdmin/Logout.aspx';
          }
        } else {
          response = resp.TokenValue;
          if (objCallBack) {
            objCallBack.getTokenCallBack(response);
          }
        }
      })
      .catch((error) => {
        response = null;
        if (objCallBack) {
          objCallBack.getTokenCallBack(response);
        }
      });
    return response;
  };

  showLoadingIcon(): void {
    this.integrationService.showSpinner('global-loadingMessage');
  }

  hideLoadingIcon = function () {
    this.integrationService.hideSpinner('global-loadingMessage');
  };
}
